module.exports = __webpack_public_path__ + "img/wines-mobile.30723072.jpg";